const styles = () => ({
  pageTitle: {
    padding: '0 36px',
  },
});

export default styles;
